import { Module } from 'vuex';

import { RootState, SavedSets } from 'frontend/types';

const savedsets: Module<SavedSets, RootState> = {
  namespaced: true,
  state: () => ({
    exist: false,
    url: undefined,
  }),
  mutations: {
    setValue(state, value: SavedSets): void {
      Object.assign(state, value);
    },
  },
  actions: {},
};

export default savedsets;
